'use strict';
import forEach from 'lodash/forEach';
import isNumber from 'lodash/isNumber';
import {getActiveTimers} from '../reducers';

export class MenuTimerController {
  static baseProps = {
    hasTimers: false,
    active: 0,
    paused: 0,
  };

  constructor(state$) {
    this.state$ = state$;
  }

  /**
   * @return {Observable<TaskInfoTimerProps>}
   */
  props$() {
    return this.state$
      .map(state => getActiveTimers(state).list)
      .distinctUntilChanged()
      .map(list => countTimers(list, MenuTimerController.baseProps))
      .distinctUntilChanged();
  }
}

function countTimers(list, baseProps) {
  const counts = {
    hasTimers: true,
    active: 0,
    paused: 0,
  };

  forEach(list, model => {
    if (model.isStopped !== true) {
      if (isNumber(model.startedAt)) {
        counts.active++;
      } else {
        counts.paused++;
      }
    }
  });

  if (counts.active > 0 || counts.paused) {
    return counts;
  } else {
    return baseProps;
  }
}



// WEBPACK FOOTER //
// ./src/js/timers/controllers/MenuTimerController.js